import 'slick-carousel';

export default {
  init() {
    $('.my-slick').slick({})
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/page-sample-slider.js